import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusEvenimentComponent } from './status-eveniment.component';
import { AddStatusEvenimentComponent } from './add-status-eveniment/add-status-eveniment.component';
import { EditStatusEvenimentComponent } from './edit-status-eveniment/edit-status-eveniment.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
    declarations: [
        StatusEvenimentComponent,
        AddStatusEvenimentComponent,
        EditStatusEvenimentComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [StatusEvenimentComponent],
})
export class StatusEvenimentModule { }
